module.exports = __webpack_public_path__ + "static/media/ride-bike.9bb5bc0d.png";